import { flattenMessages } from '../flattenMessages';

export default flattenMessages({
  common: {
    saveChanges: 'Save changes',
    cancel: 'Cancel',
    save: 'Save',
    submit: 'Submit',
    weekDays: {
      sunday: 'Sunday',
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
    },
    greeting: 'Hello, {name}!',
    clear: 'Clear',
    applyFilters: 'Apply filters',
    back: 'Back',
    next: 'Next',
    search: 'Search',
    filter: 'Filter',
    all: 'All',
    name: 'Name',
    actions: 'Actions',
    clearAllFilters: 'Clear all filters',
    status: 'Status',
    location: 'Location',
    yes: 'Yes',
    no: 'No',
    unknownError: 'Something went wrong',
    qualification: 'Qualification',
    shiftType: 'Shift Type',
    view: 'View',
    edit: 'Edit',
    deleteImage: 'Delete image',
    fileValidationError: 'Wrong file format: image should be PNG or JPG format, {sizeMb}MB max.',
    errors: {
      base: 'Something went wrong',
    },
  },
  auth: {
    login: {
      title: 'Login',
      subtitle: 'Please, provide your email or phone number to receive an OTP',
      tabEmailTitle: 'Email',
      tabPhoneTitle: 'Phone number',
      emailPlaceholder: 'e.g. jhondoe@gmail.com',
      signUpText: 'Don’t have a ShiftNex account yet? <link>Sign Up</link>',
    },
    otp: {
      title: 'Secure verification',
      subtitle: 'We’ve just sent you a temporary 6-digit code verification. Please check email and/or phone.',
      inputPlaceholder: 'Enter the code',
      resendCode: 'Resend the code',
      resendCodeSuccess: 'Code successfully resent',
    },
    adminSignUp: {
      title: 'Welcome to ShiftNex!',
      titleWithName: '{name}, welcome to ShiftNex!',
      subtitle: 'Join the ShiftNex Healthcare Platform and enjoy the way we manage healthcare staffing operations',
      otpBySmsLabel: 'Receive OTP by sms',
      otpBySmsInstructions: 'Please, fill in your phone number if you want receive the one-time password  by SMS',
      submitLabel: 'Create account',
    },
    adminSignUpDetails: {
      title: 'Agency',
      subtitle: 'Please, fill in your agency details.',
    },
    adminSignUpAddress: {
      title: 'Address',
      subtitle: 'Please, fill in your agency address details.',
    },
    footer: {
      legalMessage:
        'By using {name} you agree to the <termsLink>Terms of Service</termsLink> and <privacyLink>Privacy Policy</privacyLink>',
      version: 'Version {version}',
    },
    submitLabel: 'Continue',
    signInText: 'Already have a ShiftNex account? <link>Sign In</link>',
  },
  sidebar: {
    dashboard: 'Dashboard',
    clients: 'Clients',
    reports: 'Reports',
    settings: 'Settings',
  },
  header: {
    manageAccount: 'Manage account',
    profileMenu: {
      pauseNotificationsLabel: 'Pause notifications',
      profileSettingsLabel: 'Profile settings',
      supportLabel: 'Support chat',
      reportLabel: 'Report an issue',
      logOutLabel: 'Log out',
    },
    notificationSchedule: {
      label: 'Pause notifications for...',
      postponeMins: 'For {value, plural, one {# minute} other {# minutes}}',
      postponeHours: 'For {value, plural, one {# hour} other {# hours}}',
      postponeTomorrow: 'Until tomorrow',
    },
    refresh: {
      label: 'Last synced',
    },
  },
  comingSoon: {
    title: 'Coming soon...',
    description: 'The page is not yet available but we are working on it',
    votableDescription: {
      active:
        'We’re working hard to bring you powerful reporting features. Let us know how important this functionality is to you!',
      inactive: 'Thanks for voting! We’ll notify you when this feature is live.',
    },
    voteButton: {
      label: 'Vote for the feature',
    },
  },
  settings: {
    menu: {
      organization: {
        title: 'Organization',
      },
      rolesAndUsers: {
        title: 'Users',
      },
      systemUsers: {
        title: 'System Users',
      },
      privacyAndSecurity: {
        title: 'Privacy and security',
      },
      organizationDetails: {
        title: 'Organization details',
      },
      documents: {
        title: 'Documents',
      },
      branding: {
        title: 'Branding',
      },
      qualificationsSpecialties: {
        title: 'Qualifications & Specialties',
      },
      qualifications: {
        title: 'Qualifications',
      },
      specialties: {
        title: 'Specialties',
      },
      departments: {
        title: 'Departments',
      },
      locations: {
        title: 'Locations',
      },
    },
    organization: {
      savedSuccessfully: 'Organization details saved successfully',
      title: 'Organization details',
      subtitle: 'Please fill in your organization information so the ShiftNex can proceed with verifying your account',
      mainDetails: {
        title: 'Main details',
        subtitle: 'Please, fill in organization contact details and EIN',
      },
      address: {
        title: 'Facility address',
        subtitle: 'Please, fill in your facility address details.',
      },
      contact: {
        title: 'Main facility contact',
        subtitle: 'Please, fill in contact details',
      },
      operational: {
        title: 'Operational setup',
        subtitle: 'Set up the way organization operates',
      },
      fields: {
        orgName: {
          label: 'Organization name',
        },
        orgType: {
          label: 'Facility type',
          placeholder: 'Please select a types of your facility',
        },
        orgRegistrationDate: {
          label: 'Registration date',
        },
        numberOfEmployees: {
          label: 'Number of employees',
          placeholder: 'PLease select an option',
        },
        website: {
          label: 'Facility website',
          placeholder: 'http://example.com',
        },
        NPI: {
          label: 'NPI',
          placeholder: 'e.g. 123-45-6789',
        },
      },
    },
    qualSpeck: {
      qualifications: {
        title: 'Qualifications',
        subtitle:
          'In this section you can add qualifications used in your organization. You can select default values provided by the system or create your custom ones. Please note that qualification is mandatory for all users. Also, system default entities cannot be edited or deleted.',

        directQualBox: {
          title: 'Clinical',
          titleInfoTooltip:
            'Once a qualification is in use (mapped to a department and assigned at least to one user) it cannot be deleted or unchecked',
          emptyListPlaceholderText: 'No qualifications inside "Nurses" category',
          editQualListButtonLabel: 'Edit qualifications',
        },
        editDirectQalDialog: {
          dialogHeading: 'Clinical',
          listCounter: '{amount} qualifications',
          addButton: 'Add qualification',
          selectTitle: 'Qualification',
          selectPlaceholder: 'Qualification',
          abbreviationTitle: 'Abbreviation',
          noAbbreviationLabel: 'no qualification chosen',
        },
        otherQualBox: {
          title: 'Other',
          titleInfoTooltip:
            'Once a qualification is in use (mapped to a department and assigned at least to one user) it cannot be deleted or unchecked',
          emptyListPlaceholderText: 'No qualifications inside "Other" category',
          editQualListButtonLabel: 'Edit qualifications',
        },
        editOtherQalDialog: {
          dialogHeading: 'Other',
          listCounter: '{amount} qualifications',
          addButton: 'Add qualification',
          selectTitle: 'Qualification',
          abbreviationTitle: 'Abbreviation',
        },
        errors: {
          QualificationInUseBySpecialty:
            'This qualification is used for one or multiple entities of your organization and cannot be deleted',
          NurseQualificationInUseByInternalStaff:
            'This qualification is used for one or multiple entities of your organization and cannot be deleted',
          OtherQualificationInUseByDepartment: 'Non-clinical qualification is in use by one or more departments',
          NurseQualificationInUseByShift: 'This qualification is used for one or multiple shifts and cannot be deleted',
          NurseQualificationInUseByDepartment:
            'This qualification is used for one or multiple entities of your organization and cannot be deleted',
          NurseQualificationInUseByExternalStaff:
            'This qualification is used for one or multiple entities of your organization and cannot be deleted',
        },
      },
      specialties: {
        title: 'Specialties',
        subtitle:
          'Here you can add specialties of your facility. Each specialty should be mapped to one or multiple qualifications.',
        specialtiesCounter: '{amount} Specialties',
        addSpecialtyButtonLabel: 'Add specialty',
        table: {
          noRows: {
            title: 'No specialties yet',
            subtitle: "You don't have any specialties yet",
          },
          columns: {
            specialty: {
              heading: 'Specialty',
            },
            qualification: {
              heading: 'Qualification',
            },
          },
        },
        editSpecialtyDialog: {
          heading: 'Edit Specialty',
          selectTitle: 'Specialty title',
          selectTitlePlaceholder: 'Please select specialty',
          directQualificationsSectHeading: 'Clinical qualifications',
          otherQualificationsSectHeading: 'Other qualifications',
          errors: {
            qualNotSelected: 'Please select at least one qualification',
          },
        },
        addSpecialtyDialog: {
          heading: 'New Specialty',
          selectTitle: 'Specialty title',
          selectTitlePlaceholder: 'Please select specialty',
          directQualificationsSectHeading: 'Clinical qualifications',
          otherQualificationsSectHeading: 'Other qualifications',
          errors: {
            qualNotSelected: 'Please select at least one qualification',
          },
        },
      },
    },
    departments: {
      listPage: {
        title: 'Departments',
        subtitle:
          'Add departments to your organization structure. Than you can add sub-departments and lower sub-levels (up to five). In this tab you can also select qualifications and specialties required for each department. Note that sub-departments qualifications can be added from department’s list.',
        departmentsCounter: '{amount} Departments',
        addDepartmentButton: 'Add department',
        itemTypeLabels: {
          department: 'Department',
          subdepartment: 'Sub-department',
        },
        itemMenu: {
          editButton: {
            tooltip: 'Edit',
          },
          removeButton: {
            tooltip: 'Delete',
          },
          addButton: {
            tooltip: 'Add a sub element',
          },
        },
      },
      newDepartmentDialog: {
        dialogHeading: 'New department',
        directQualificationsSectHeading: 'Clinical qualifications',
        otherQualificationsSectHeading: 'Other qualifications',
        specialtiesSectHeading: 'Specialties',
        deptTypeSelection: {
          title: 'Type',
        },
        deptTitleSelection: {
          title: 'Title',
        },
        addSpecialtyButton: {
          label: 'Add specialty',
        },
        specialtySection: {
          title: 'Specialty',
        },
      },
      editDepartmentDialog: {
        dialogHeading: 'Edit department',
        directQualificationsSectHeading: 'Clinical qualifications',
        otherQualificationsSectHeading: 'Other qualifications',
        specialtiesSectHeading: 'Specialties',
        deptTypeSelection: {
          title: 'Type',
        },
        deptTitleSelection: {
          title: 'Title',
        },
        addSpecialtyButton: {
          label: 'Add specialty',
        },
        specialtySection: {
          title: 'Specialty',
        },
      },
      newSubDepartmentDialog: {
        dialogHeading: 'New sub-department',
        directQualificationsSectHeading: 'Clinical qualifications',
        otherQualificationsSectHeading: 'Other qualifications',
        specialtiesSectHeading: 'Specialties',
        deptParentTitleSelection: {
          title: 'Parent entity title',
        },
        deptTypeSelection: {
          title: 'Type',
        },
        deptTitleSelection: {
          title: 'Title',
        },
        addSpecialtyButton: {
          label: 'Add specialty',
        },
        specialtySection: {
          title: 'Specialty',
        },
      },
      editSubDepartmentDialog: {
        dialogHeading: 'Edit sub-department',
        directQualificationsSectHeading: 'Clinical qualifications',
        otherQualificationsSectHeading: 'Other qualifications',
        specialtiesSectHeading: 'Specialties',
        deptParentTitleSelection: {
          title: 'Parent entity title',
        },
        deptTypeSelection: {
          title: 'Type',
        },
        deptTitleSelection: {
          title: 'Title',
        },
        addSpecialtyButton: {
          label: 'Add specialty',
        },
        specialtySection: {
          title: 'Specialty',
        },
      },
      locationSpecific: 'Location specific',
      qualificationIsRequiredError: 'At least one qualification should be selected',
    },
    locations: {
      listPage: {
        title: 'Locations',
        subtitle:
          'This section displays the list of locations included in your facility. In ‘Structure’ sub-tab you can view and edit your organization hierarchical tree and it’s entities',
        locationsCounter: '{amount} Locations',
        addLocationButtonLabel: 'Add location',
        table: {
          noRows: {
            title: 'No locations yet',
            subtitle: "You don't have any locations yet",
          },
          columns: {
            name: {
              heading: 'Location name',
            },
            region: {
              heading: 'Region',
            },
            contact: {
              heading: 'Main contact',
            },
            email: {
              heading: 'Email',
            },
            status: {
              heading: 'Status',
            },
          },
        },
      },
      newLocationPage: {
        heading: 'New location',
      },
      editPage: {
        backButton: {
          label: 'Back to Locations',
        },
        tabs: {
          general: {
            label: 'General details',
            form: {
              main: {
                heading: 'Main details',
                subtitle: "Enter the location's basic details such as name and contact information.",
                locationName: {
                  label: 'Location name',
                  placeholder: 'Please add a name for location',
                },
                isActive: {
                  label: 'Location is active',
                },
                isHeadquarters: {
                  label: 'Location is a headquarters',
                },
              },
              address: {
                heading: 'Location address',
                subtitle: 'Provide the full address for this location.',
              },
              contact: {
                heading: 'Main location contact',
                subtitle: 'Add the primary contact person’s details for this location.',
                primaryContactName: {
                  label: "Primary contact's full name",
                  placeholder: 'Enter full name',
                },
                contactJobTitle: {
                  label: 'Job title',
                  placeholder: 'Enter job title',
                },
                primaryPhoneNumber: {
                  label: 'Primary phone number',
                  placeholder: 'Enter job title',
                },
                secondaryPhoneNumber: {
                  label: 'Secondary phone number',
                  placeholder: 'Enter job title',
                },
              },
              operational: {
                heading: 'Operational setup',
                subtitle: 'Choose the starting day of the operational week for this location.',
              },
            },
          },
          structure: {
            label: 'Location structure',
            addDeptButton: {
              label: 'Add department',
            },
          },
        },
      },
      table: {
        noRows: {
          title: 'No locations yet',
          subtitle: "You don't have any locations yet",
        },
      },
    },
    users: {
      title: 'System users',
      subtitle:
        'This section displays non-clinical personnel, such as administrative and management staff, who handle operational tasks but are not eligible for shift assignments',
      status: {
        InviteFailed: 'Invite failed',
        Invited: 'Invited',
        Pending: 'Pending',
        Active: 'Active',
        Deactivated: 'Deactivated',
      },
      usersCount: '{number, plural, =0 {No users} one {# user} other {# users} }',
      table: {
        noRows: {
          title: 'No users yet',
          subtitle: 'You don’t have any users yet added',
        },
      },
      addUserButtonLabel: 'Add user',
      userForm: {
        title: 'Add system user',
        editTitle: 'Edit system user',
        stepGeneral: 'General',
        stepEmployment: 'Employment & Qualifications',
        success: 'User has been created successfully',
        submitNew: {
          label: 'Invite',
        },
        validationErrorIconTooltip: 'Some validation errors occurred',
      },
      error: {
        409: 'User with this email already exists',
      },
    },
  },

  forms: {
    requiredFieldsMissing: '{number} mandatory fields missing',
    fieldIsRequired: 'This field is required',
    maxLengthError: 'Max length is {number}',
    minLengthError: 'Min length is {number}',
    invalidPhoneNumber: 'Please, enter valid phone number',
    invalidEIN: 'Please, check the format of the input',
    invalidZipCode: 'Please, enter valid zip code',
    invalidEmail: 'The entered value is not an email',
    emptyLinesOfBusiness: 'Select at least one business line of the organization',
    invalidWebsite: 'Please, enter valid website',
    positiveNumberOnly: 'Please, enter a positive number',
    maxValueError: 'Max number is {number}',
    minValueError: 'Min number is {number}',
  },
  filters: {
    dateRange: {
      previousQuarter: 'Previous quarter',
      previousWeek: 'Previous week',
      today: 'Today',
      thisWeek: 'This week',
      thisQuarter: 'This quarter',
      nextWeek: 'Next week',
      nextQuarter: 'Next quarter',
    },
    sharedWithin: {
      menuLabel: 'Shared within',
      last24Hours: 'Last 24 hours',
      last48Hours: 'Last 48 hours',
      allTime: 'All time',
      last7Days: 'Last 7 days',
      last30Days: 'Last 30 days',
    },
    applyButtonLabel: 'Apply filters',
    departments: {
      label: 'Departments',
    },
    statuses: {
      label: 'Status',
    },
  },
  reports: {
    title: 'Reporting',
  },
  clients: {
    subpageMenu: {
      requests: 'Requests',
      agencies: 'Agencies',
      facilities: 'Facilities',
    },
    menuButton: {
      agency: 'Add agency',
      facility: 'Add facility',
    },

    requests: {
      orgTypes: {
        agency: {
          label: 'AX',
        },
        facility: {
          label: 'FX',
        },
      },
      table: {
        noRows: {
          title: 'No customer requests yet',
          subtitle: "Shiftnex don't have any customer requests yet",
        },
        fields: {
          orgType: {
            heading: 'Type',
          },
          createdOn: {
            heading: 'Created at',
          },
          orgName: {
            heading: 'Organization name',
          },
          tenant: {
            heading: 'Tenant',
          },
          address: {
            heading: 'Address',
          },
          phone: {
            heading: 'Phone',
          },
          mainContact: {
            heading: 'Contact',
          },
          status: {
            heading: 'Status',
          },
          actions: {
            heading: 'Quick actions',
            buttons: {
              activate: {
                label: 'Activate',
              },
              deactivate: {
                label: 'Deactivate',
              },
            },
          },
        },
      },
    },
    agencies: {
      statuses: {
        active: 'Active',
        disconnected: 'Disconnected',
        invited: 'Invited',
        onReview: 'On review',
        pending: 'Pending',
      },
      filters: {
        status: {
          label: 'Status',
        },
        search: {
          label: 'Search',
        },
      },
      table: {
        noRows: {
          title: 'No agencies yet',
          subtitle: "Shiftnex don't have any agency clients yet",
        },
        fields: {
          orgName: {
            heading: 'Agency name',
          },
          tenant: {
            heading: 'Tenant',
          },
          mainContact: {
            heading: 'Contact',
          },
          phone: {
            heading: 'Phone',
          },
          createdOn: {
            heading: 'Created at',
          },
          address: {
            heading: 'Address',
          },
          status: {
            heading: 'Status',
          },
          linesOfBusiness: {
            heading: 'Lines of business',
          },
        },
      },
    },
    facilities: {
      statuses: {
        active: 'Active',
        disconnected: 'Disconnected',
        invited: 'Invited',
        onReview: 'On review',
        pending: 'Pending',
      },
      filters: {
        status: {
          label: 'Status',
        },
        search: {
          label: 'Search',
        },
      },
      table: {
        noRows: {
          title: 'No facilities yet',
          subtitle: "Shiftnex don't have any facility clients yet",
        },
        fields: {
          orgName: {
            heading: 'Facility name',
          },
          tenant: {
            heading: 'Tenant',
          },
          mainContact: {
            heading: 'Contact',
          },
          phone: {
            heading: 'Phone',
          },
          status: {
            heading: 'Status',
          },
          createdOn: {
            heading: 'Created at',
          },
          address: {
            heading: 'Address',
          },
          linesOfBusiness: {
            heading: 'Lines of business',
          },
          actionMenu: {
            activate: {
              label: 'Activate',
            },
            deactivate: {
              label: 'Deactivate',
            },
          },
        },
      },
    },
    drawers: {
      agency: {
        add: {
          dialogHeading: 'Add agency',
          menuButtons: {
            back: {
              label: 'Close',
            },
            addActivate: {
              label: 'Add and activate',
            },
            add: {
              label: 'Add',
            },
          },
          details: {
            sectTitle: 'Agency details',
            agencyName: {
              label: 'Agency name',
              placeholder: 'Enter agency name',
            },
            domainName: {
              label: 'Domain name',
              placeholder: 'example',
            },
            agencyType: {
              label: 'Agency type',
              placeholder: 'Agency type',
            },
            linesOfBusiness: {
              label: 'Lines of business',
              placeholder: 'Lines of business',
            },
          },
          contact: {
            sectTitle: 'Contact person details',
            firstName: {
              label: 'First name',
              placeholder: 'Enter first name',
            },
            lastName: {
              label: 'Last name',
              placeholder: 'Enter last name',
            },
            email: {
              label: 'Email',
              placeholder: 'Enter email',
            },
            phoneNumber: {
              label: 'Phone number',
              placeholder: 'Enter phone number',
            },
          },
        },
        edit: {},
      },
    },
  },
});
